import {Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {inject} from '@angular/core';
import {AppConstants} from '../../core/app-constants';
import {AuthenticationService} from '../../modules/auth/services/authentication.service';

export async function authenticationGuardFn(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const authService = inject(AuthenticationService);
    const router = inject(Router);


    if (await authService.isAuthenticated()) {
        return true;
    }

    return router.createUrlTree([AppConstants.LOGIN_URL], {queryParams: {redirect: state.url}});
}
